var _path, _path2, _path3, _path4, _rect, _rect2, _path5, _path6, _path7, _path8, _path9, _path10, _rect3, _rect4, _circle, _path11, _path12, _circle2, _path13, _path14, _circle3, _path15, _path16, _rect5, _rect6, _path17, _path18, _path19, _path20, _path21, _path22, _circle4, _circle5, _circle6, _circle7, _circle8, _path23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "undraw_data_trends_re_2cdy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 282.929,
    height: 227.311,
    viewBox: "0 0 282.929 227.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M452.816,629.855l-6.054-2.549-4.153-30.347h-55.3l-4.5,30.223-5.416,2.708a1.286,1.286,0,0,0,.575,2.436h74.351a1.286,1.286,0,0,0,.5-2.471Z",
    transform: "translate(-273.816 -405.016)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M406.351,545.068H134.694a5.382,5.382,0,0,1-5.37-5.382V501.379h282.4v38.307a5.382,5.382,0,0,1-5.37,5.382Z",
    transform: "translate(-129.076 -349.087)",
    fill: "#ccc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M411.655,304.677H128.726V140.768a6.5,6.5,0,0,1,6.488-6.488H405.167a6.5,6.5,0,0,1,6.488,6.488Z",
    transform: "translate(-128.726 -134.28)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M411.537,309.56H162.4a5.007,5.007,0,0,1-5-5v-136.6a5.008,5.008,0,0,1,5-5H411.537a5.008,5.008,0,0,1,5,5v136.6A5.007,5.007,0,0,1,411.537,309.56Z",
    transform: "translate(-145.506 -151.06)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_395",
    "data-name": "Rectangle 395",
    width: 60.152,
    height: 45.954,
    transform: "translate(203.22 33.98)",
    fill: "#f2f2f2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_396",
    "data-name": "Rectangle 396",
    width: 54.174,
    height: 41.388,
    transform: "translate(206.209 36.264)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M692.916,255.032h.021a14.444,14.444,0,0,0,.323-28.828.33.33,0,0,0-.249.086.326.326,0,0,0-.106.239l-.316,28.169A.331.331,0,0,0,692.916,255.032Z",
    transform: "translate(-458.669 -188.068)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M660.508,237.433a.425.425,0,0,1,.3.128l9.7,9.917a.421.421,0,0,1,.121.3l-.151,13.479a.42.42,0,0,1-.137.307.426.426,0,0,1-.32.111,14.538,14.538,0,0,1-9.832-24.1.426.426,0,0,1,.307-.144Z",
    transform: "translate(-437.589 -194.64)",
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M677.112,225.927a.427.427,0,0,1,.29.119.42.42,0,0,1,.13.31l-.136,12.162a.423.423,0,0,1-.726.291l-8.462-8.654a.424.424,0,0,1,.023-.615,14.569,14.569,0,0,1,8.855-3.613Z",
    transform: "translate(-444.332 -187.907)",
    fill: "#00f000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M672.016,306.075a2.594,2.594,0,1,1-2.565-2.623A2.594,2.594,0,0,1,672.016,306.075Z",
    transform: "translate(-443.595 -233.27)",
    fill: "#00f000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M689.881,306.276a2.594,2.594,0,1,1-2.565-2.623A2.594,2.594,0,0,1,689.881,306.276Z",
    transform: "translate(-454.049 -233.388)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M707.747,306.476a2.594,2.594,0,1,1-2.565-2.623A2.594,2.594,0,0,1,707.747,306.476Z",
    transform: "translate(-464.503 -233.505)",
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_397",
    "data-name": "Rectangle 397",
    width: 60.152,
    height: 45.954,
    transform: "translate(202.586 87.167)",
    fill: "#f2f2f2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_398",
    "data-name": "Rectangle 398",
    width: 54.174,
    height: 41.388,
    transform: "translate(205.575 89.451)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 2.249,
    cy: 2.249,
    r: 2.249,
    transform: "translate(212.518 98.555)",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M697.492,372.522a1.525,1.525,0,0,1,0,3.051H673.834a1.525,1.525,0,1,1,0-3.051h23.657m0-.374H673.834a1.9,1.9,0,1,0,0,3.8h23.657a1.9,1.9,0,1,0,0-3.8Z",
    transform: "translate(-446.584 -273.468)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M683.24,375.947H665.431a1.9,1.9,0,1,1,0-3.8H683.24a1.9,1.9,0,0,1,0,3.8Z",
    transform: "translate(-441.667 -273.468)",
    fill: "#00f000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 2.249,
    cy: 2.249,
    r: 2.249,
    transform: "translate(212.518 107.895)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M697.492,395.037a1.525,1.525,0,1,1,0,3.051H673.834a1.525,1.525,0,0,1,0-3.051h23.657m0-.374H673.834a1.9,1.9,0,0,0,0,3.8h23.657a1.9,1.9,0,0,0,0-3.8Z",
    transform: "translate(-446.584 -286.643)",
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M689.964,398.462H665.43a1.9,1.9,0,1,1,0-3.8h24.534a1.9,1.9,0,0,1,0,3.8Z",
    transform: "translate(-441.666 -286.643)",
    fill: "#00f000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 2.249,
    cy: 2.249,
    r: 2.249,
    transform: "translate(212.518 117.236)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M697.492,417.552a1.525,1.525,0,1,1,0,3.051H673.834a1.525,1.525,0,0,1,0-3.051h23.657m0-.374H673.834a1.9,1.9,0,0,0,0,3.8h23.657a1.9,1.9,0,0,0,0-3.8Z",
    transform: "translate(-446.584 -299.817)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M675.393,420.977H665.43a1.9,1.9,0,1,1,0-3.8h9.963a1.9,1.9,0,1,1,0,3.8Z",
    transform: "translate(-441.666 -299.818)",
    fill: "#00f000"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_399",
    "data-name": "Rectangle 399",
    width: 168.054,
    height: 86.127,
    transform: "translate(21.236 42.111)",
    fill: "#f2f2f2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_400",
    "data-name": "Rectangle 400",
    width: 156.85,
    height: 77.568,
    transform: "translate(26.838 46.391)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M362.832,326.247H248.491a.358.358,0,0,1-.358-.358v-54.8a.358.358,0,1,1,.716,0v54.446H362.832a.358.358,0,0,1,0,.716Z",
    transform: "translate(-198.597 -214.123)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M291.717,371.852h-10.4a1.063,1.063,0,0,1-1.062-1.062V356.454a1.063,1.063,0,0,1,1.062-1.062h10.4a1.063,1.063,0,0,1,1.062,1.062V370.79A1.063,1.063,0,0,1,291.717,371.852Z",
    transform: "translate(-217.393 -263.663)",
    fill: "#00f000"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M337.432,352.672h-10.4a1.063,1.063,0,0,1-1.062-1.062V323.676a1.063,1.063,0,0,1,1.062-1.062h10.4a1.063,1.063,0,0,1,1.062,1.062V351.61A1.063,1.063,0,0,1,337.432,352.672Z",
    transform: "translate(-244.143 -244.483)",
    fill: "#00f000"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M383.148,371.852h-10.4a1.063,1.063,0,0,1-1.062-1.062V356.454a1.063,1.063,0,0,1,1.062-1.062h10.4a1.063,1.063,0,0,1,1.062,1.062V370.79A1.063,1.063,0,0,1,383.148,371.852Z",
    transform: "translate(-270.893 -263.663)",
    fill: "#00f000"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M428.864,345.1h-10.4a1.04,1.04,0,0,1-1.062-1.014v-33.4a1.04,1.04,0,0,1,1.062-1.014h10.4a1.04,1.04,0,0,1,1.062,1.014v33.4A1.04,1.04,0,0,1,428.864,345.1Z",
    transform: "translate(-297.644 -236.912)",
    fill: "#00f000"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M474.579,331.474h-10.4a1.063,1.063,0,0,1-1.062-1.062V287.449a1.063,1.063,0,0,1,1.062-1.062h10.4a1.063,1.063,0,0,1,1.062,1.062v42.963a1.063,1.063,0,0,1-1.062,1.062Z",
    transform: "translate(-324.394 -223.285)",
    fill: "#00f000"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 2.147,
    cy: 2.147,
    r: 2.147,
    transform: "translate(66.977 83.141)",
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 2.147,
    cy: 2.147,
    r: 2.147,
    transform: "translate(85.942 69.185)",
    fill: "#3f3d56"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 2.147,
    cy: 2.147,
    r: 2.147,
    transform: "translate(104.907 83.141)",
    fill: "#3f3d56"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 2.147,
    cy: 2.147,
    r: 2.147,
    transform: "translate(123.873 62.386)",
    fill: "#3f3d56"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 2.147,
    cy: 2.147,
    r: 2.147,
    transform: "translate(142.838 54.514)",
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M204.3,165.546l-19.01-14.239-18.751,14.044-.429-.572,19.18-14.366,18.92,14.171,18.8-20.575.075-.031,18.965-7.641.268.664-18.89,7.611Z",
    transform: "translate(-97.196 -79.777)",
    fill: "#3f3d56"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.198f7f5d.svg";
export { ForwardRef as ReactComponent };